class FJBorderProperties {
  constructor(borderSize, shadowSize, borderColor, shadowColor, shadowAlpha, shadowBlurStrength, direction = 0, borderAlpha = 255, offset = 0) {
    this.borderSize = borderSize, this.shadowSize = shadowSize, this.borderColor = borderColor, this.shadowColor = shadowColor, this.shadowAlpha = shadowAlpha, this.direction = direction, this.shadowBlurStrength = shadowBlurStrength, this.offset = offset, this.borderAlpha = borderAlpha;
  }
  get offset() {
    return this._offset;
  }
  set offset(offset) {
    isNaN(offset) || offset < 0 ? console.warn(`Invalid value for the border offset: ${offset}`) : this._offset = offset;
  }
  get borderAlpha() {
    return this._borderAlpha;
  }
  set borderAlpha(alpha) {
    isNaN(alpha) || alpha < 0 ? console.warn(`Invalid value for the border alpha: ${alpha}`) : this._borderAlpha = alpha;
  }
  get direction() {
    return this._direction;
  }
  set direction(direction) {
    isNaN(direction) || direction < 0 ? console.warn(`Invalid value for the border direction: ${direction}`) : this._direction = direction;
  }
  get borderSize() {
    return this._boderSize;
  }
  set borderSize(size) {
    isNaN(size) || size < 0 ? console.warn(`Invalid value for the border size: ${size}`) : this._boderSize = size;
  }
  get shadowSize() {
    return this._shadowSize;
  }
  set shadowSize(size) {
    isNaN(size) || size < 0 ? console.warn(`Invalid value for the shadow size: ${size}`) : this._shadowSize = size;
  }
  get extraSize() {
    return this._boderSize + this._shadowSize;
  }
  get borderColor() {
    return this._borderColor;
  }
  set borderColor(value) {
    return !Array.isArray(value) || value.length > 3 ? (console.warn("The border color has to be an array of size 3"), this._borderColor) : value.reduce((previous, current) => previous || current < 0 || current > 255, false) ? (console.warn("Each component of the border color has to be in the range [0,255]"), this._borderColor) : (this._borderColor = value.map((x) => x), this._borderColor);
  }
  get shadowColor() {
    return this._shadowColor;
  }
  set shadowColor(value) {
    return !Array.isArray(value) || value.length > 3 ? (console.warn("The shadow color has to be an array of size 3"), this._shadowColor) : value.reduce((previous, current) => previous || current < 0 || current > 255, false) ? (console.warn("Each component of the shadow color has to be in the range [0,255]"), this._shadowColor) : (this._shadowColor = value.map((x) => x), this._shadowColor);
  }
  get shadowAlpha() {
    return this._shadowAlpha;
  }
  set shadowAlpha(value) {
    isNaN(value) || value < 0 || value > 255 ? console.warn(`Invalid value for the shadow alpha: ${value}`) : this._shadowAlpha = value;
  }
  get shadowBlurStrength() {
    return this._shadowBlurStrength;
  }
  set shadowBlurStrength(value) {
    isNaN(value) || value < 0 || value > 1 ? console.warn(`Invalid value for the shadow blur strength: ${value}`) : this._shadowBlurStrength = value;
  }
}
const FJBorderProperties$1 = FJBorderProperties;

const FJColorUtil = {
  hexToRgba: function(hex, opacity) {
    let RGBA = "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + opacity / 100 + ")";
    return {
      red: parseInt("0x" + hex.slice(1, 3)),
      green: parseInt("0x" + hex.slice(3, 5)),
      blue: parseInt("0x" + hex.slice(5, 7)),
      rgba: RGBA
    };
  },
  hexToRgb: function(hex) {
    let hexColor = /^#/.test(hex) ? hex.slice(1) : hex, r, g, b;
    hexColor = /^[0-9a-f]{3}|[0-9a-f]{6}$/i.test(hexColor) ? hexColor : "fffff";
    if (hexColor.length === 3) {
      hexColor = hexColor.replace(/(\w)(\w)(\w)/gi, "$1$1$2$2$3$3");
    }
    r = hexColor.slice(0, 2);
    g = hexColor.slice(2, 4);
    b = hexColor.slice(4, 6);
    r = parseInt(r, 16);
    g = parseInt(g, 16);
    b = parseInt(b, 16);
    return { r, g, b };
  },
  rgbToYuv: function(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    let y = 0.299 * r + 0.587 * g + 0.114 * b;
    let u = (b - y) * 0.492;
    let v = (r - y) * 0.877;
    return { y, u, v };
  },
  rgb2Lab: function(rgb) {
    let r = rgb.r / 255, g = rgb.g / 255, b = rgb.b / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 8856e-6 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 8856e-6 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  },
  differenceRgb: function(rgb1, rgb2) {
    let labA = FJColorUtil.rgb2Lab(rgb1);
    let labB = FJColorUtil.rgb2Lab(rgb2);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1 + 0.045 * c1;
    let sh = 1 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
  },
  /**
   * @description 检查color是否符合规则
   * @param color
   * @returns {boolean}
   */
  isEffectiveColor: function(color) {
    let re1 = /^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/i;
    let re2 = /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/;
    let re3 = /^rgba\((\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d*(?:\.\d+)?)\)$/;
    let re4 = /^hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)$/;
    let re5 = /^hsl\(\s*(\d+)\s*,\s*(\d*(?:\.\d+)?%)\s*,\s*(\d*(?:\.\d+)?%)\)$/;
    let re6 = /^#([a-f0-9]{8}|[a-f0-9]{4})\b$/;
    let colorList = [
      "LightPink",
      "Pink",
      "Crimson",
      "LavenderBlush",
      "PaleVioletRed",
      "HotPink",
      "DeepPink",
      "MediumVioletRed",
      "Orchid",
      "Thistle",
      "plum",
      "Violet",
      "Magenta",
      "Fuchsia",
      "DarkMagenta",
      "Purple",
      "MediumOrchid",
      "DarkVoilet",
      "DarkOrchid",
      "Indigo",
      "BlueViolet",
      "MediumPurple",
      "MediumSlateBlue",
      "SlateBlue",
      "DarkSlateBlue",
      "Lavender",
      "GhostWhite",
      "Blue",
      "MediumBlue",
      "MidnightBlue",
      "DarkBlue",
      "Navy",
      "RoyalBlue",
      "CornflowerBlue",
      "LightSteelBlue",
      "LightSlateGray",
      "SlateGray",
      "DoderBlue",
      "AliceBlue",
      "SteelBlue",
      "LightSkyBlue",
      "SkyBlue",
      "DeepSkyBlue",
      "LightBLue",
      "PowDerBlue",
      "CadetBlue",
      "Azure",
      "LightCyan",
      "PaleTurquoise",
      "Cyan",
      "Aqua",
      "DarkTurquoise",
      "DarkSlateGray",
      "DarkCyan",
      "Teal",
      "MediumTurquoise",
      "LightSeaGreen",
      "Turquoise",
      "Auqamarin",
      "MediumAquamarine",
      "MediumSpringGreen",
      "MintCream",
      "SpringGreen",
      "SeaGreen",
      "Honeydew",
      "LightGreen",
      "PaleGreen",
      "DarkSeaGreen",
      "LimeGreen",
      "Lime",
      "ForestGreen",
      "Green",
      "DarkGreen",
      "Chartreuse",
      "LawnGreen",
      "GreenYellow",
      "OliveDrab",
      "Beige",
      "LightGoldenrodYellow",
      "Ivory",
      "LightYellow",
      "Yellow",
      "Olive",
      "DarkKhaki",
      "LemonChiffon",
      "PaleGodenrod",
      "Khaki",
      "Gold",
      "Cornislk",
      "GoldEnrod",
      "FloralWhite",
      "OldLace",
      "Wheat",
      "Moccasin",
      "Orange",
      "PapayaWhip",
      "BlanchedAlmond",
      "NavajoWhite",
      "AntiqueWhite",
      "Tan",
      "BrulyWood",
      "Bisque",
      "DarkOrange",
      "Linen",
      "Peru",
      "PeachPuff",
      "SandyBrown",
      "Chocolate",
      "SaddleBrown",
      "SeaShell",
      "Sienna",
      "LightSalmon",
      "Coral",
      "OrangeRed",
      "DarkSalmon",
      "Tomato",
      "MistyRose",
      "Salmon",
      "Snow",
      "LightCoral",
      "RosyBrown",
      "IndianRed",
      "Red",
      "Brown",
      "FireBrick",
      "DarkRed",
      "Maroon",
      "White",
      "WhiteSmoke",
      "Gainsboro",
      "LightGrey",
      "Silver",
      "DarkGray",
      "Gray",
      "DimGray",
      "Black"
    ];
    let isColor = colorList.findIndex((c) => {
      return c.toLocaleUpperCase() === color.toLocaleUpperCase();
    });
    return re2.test(color) || re1.test(color) || re3.test(color) || re4.test(color) || re5.test(color) || re6.test(color) || isColor !== -1;
  },
  //hex颜色转rgb颜色
  HexToRgb: function(str) {
    const r = /^\#?[0-9A-Fa-f]{6}$/;
    if (!r.test(str)) {
      return null;
    }
    str = str.replace("#", "");
    const hxs = str.match(/../g);
    for (let i = 0; i < 3; i++)
      hxs[i] = parseInt(hxs[i], 16);
    return hxs;
  },
  //GRB颜色转Hex颜色
  RgbToHex: function(a, b, c) {
    const r = /^\d{1,3}$/;
    if (!r.test(a) || !r.test(b) || !r.test(c)) {
      console.log("\u8F93\u5165\u9519\u8BEF\u7684rgb\u989C\u8272\u503C", a, b, c);
      return null;
    }
    const hexs = [a.toString(16), b.toString(16), c.toString(16)];
    for (let i = 0; i < 3; i++)
      if (hexs[i].length === 1)
        hexs[i] = "0" + hexs[i];
    return "#" + hexs.join("");
  },
  //得到hex颜色值为color的加深颜色值，level为加深的程度，限0-1之间
  getDarkColor: function(color, level) {
    const r = /^\#?[0-9A-F]{6}$/;
    if (!r.test(color))
      return window.alert("\u8F93\u5165\u9519\u8BEF\u7684hex\u989C\u8272\u503C");
    const rgbc = this.HexToRgb(color);
    for (let i = 0; i < 3; i++)
      rgbc[i] = Math.floor(rgbc[i] * (1 - level));
    return this.RgbToHex(rgbc[0], rgbc[1], rgbc[2]);
  },
  /**
   * @desc 获取颜色的亮色
   * @param color
   * @param level
   * @returns {*|void|string}
   */
  getLightColor: function(color, level) {
    const r = /^\#?[0-9A-Fa-f]{6}$/;
    if (!r.test(color)) {
      return null;
    }
    const rgbc = this.HexToRgb(color);
    for (let i = 0; i < 3; i++)
      rgbc[i] = Math.floor((255 - rgbc[i]) * level + rgbc[i]);
    return this.RgbToHex(rgbc[0], rgbc[1], rgbc[2]);
  },
  // 获取根据基础颜色衍生的后续颜色
  getDeriveColorsFromBaseColors: function(baseColors, totalColors) {
    const __interpolateColor = (color1, color2, factor) => {
      let result = color1.slice();
      for (let i = 0; i < 3; i++) {
        result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
      }
      return result;
    };
    const colors = [...baseColors];
    const numBaseColors = baseColors.length;
    const remainingColors = totalColors - numBaseColors;
    const colorsPerSegment = Math.floor(remainingColors / (numBaseColors - 1));
    const extraColors = remainingColors % (numBaseColors - 1);
    for (let i = 0; i < numBaseColors - 1; i++) {
      const color1 = FJColorUtil.HexToRgb(baseColors[i]);
      const color2 = FJColorUtil.HexToRgb(baseColors[i + 1]);
      const segmentLength = colorsPerSegment + (i < extraColors ? 1 : 0);
      for (let j = 1; j <= segmentLength; j++) {
        const factor = j / (segmentLength + 1);
        const interpolatedColor = __interpolateColor(color1, color2, factor);
        colors.push(FJColorUtil.RgbToHex(interpolatedColor[0], interpolatedColor[1], interpolatedColor[2]));
      }
    }
    return colors.slice(0, totalColors);
  }
};
const FJColorUtil$1 = FJColorUtil;

const FJShaderUtil = {
  /**
   * @description 基本片段着色器代码 ：渲染一个纹理，可以选择是否预乘Alpha值。
   * @returns {string}
   */
  getBasicFragmentShaderCode() {
    return `
        precision mediump float;

        varying vec2 textCoord;
        uniform sampler2D texture;
        uniform bool premultipleAlpha;

        void main(void) 
        {
            vec4 textureColor = texture2D(texture, textCoord.xy);
            vec4 color = textureColor;
            
            if(premultipleAlpha)
                color.rgb *= color.a;

            gl_FragColor = color;
        }`;
  },
  /**
   * @description 阈值片段着色器 基于Alpha值进行阈值操作。
   * 获取纹理的Alpha值。
   * 如果Alpha值小于阈值，则颜色为黑色，否则为白色。
   * 最终输出颜色，Alpha值固定为1.0。
   * @returns {string}
   */
  getThresholdFragmentShaderCode() {
    return `
        precision mediump float;

        varying vec2 textCoord;
        
        uniform sampler2D texture;
        uniform float thresHold;

        void main(void) 
        {
            float alpha = texture2D(texture, textCoord.xy).a;
            vec3 color = alpha < thresHold ? vec3(0.0) : vec3(1.0);

            gl_FragColor = vec4(color.rgb, 1.0);
        }`;
  },
  /**
   * @description 扩散片段着色器 对图像进行扩散处理，类似于高斯模糊。
   * 变量：
   * uniform bool horizontal;：决定扩散方向（水平方向或垂直方向）。
   * uniform float textureWidth; 和 uniform float textureHeight;：纹理的宽度和高度。
   * uniform bool normalized;：是否归一化结果。
   * 主要操作：
   * 计算纹理偏移。
   * 根据方向（水平或垂直）累加加权后的纹理颜色。
   * 最终输出扩散后的颜色。
   * @returns {string}
   */
  //     getDilatationShaderCode() {
  //         return `
  // precision mediump float; // 为 float 变量指定中等精度
  //
  // varying vec2 textCoord;
  //
  // uniform sampler2D texture;
  // uniform float textureWidth;
  // uniform float textureHeight;
  //
  // void main(void)
  // {
  //     vec2 textOffset = vec2(1.0 / textureWidth, 1.0 / textureHeight);
  //     float maxValue = texture2D(texture, textCoord).r; // 初始化为当前像素值
  //
  //     // 检查八个邻居像素
  //     maxValue = max(maxValue, texture2D(texture, textCoord + vec2(textOffset.x, 0.0)).r);
  //     maxValue = max(maxValue, texture2D(texture, textCoord - vec2(textOffset.x, 0.0)).r);
  //     maxValue = max(maxValue, texture2D(texture, textCoord + vec2(0.0, textOffset.y)).r);
  //     maxValue = max(maxValue, texture2D(texture, textCoord - vec2(0.0, textOffset.y)).r);
  //     maxValue = max(maxValue, texture2D(texture, textCoord + vec2(textOffset.x, textOffset.y)).r);
  //     maxValue = max(maxValue, texture2D(texture, textCoord - vec2(textOffset.x, textOffset.y)).r);
  //     maxValue = max(maxValue, texture2D(texture, textCoord + vec2(textOffset.x, -textOffset.y)).r);
  //     maxValue = max(maxValue, texture2D(texture, textCoord - vec2(textOffset.x, -textOffset.y)).r);
  //
  //     vec3 dilatation = vec3(maxValue);
  //     gl_FragColor = vec4(dilatation.rgb, 1.0);
  // }
  // `;
  //     },
  getDilatationShaderCode() {
    return `precision mediump float;
        
        varying vec2 textCoord;
        
        uniform sampler2D texture;
        uniform bool horizontal;
        
        uniform float textureWidth;
        uniform float textureHeight;
        uniform bool normalized;
        
        void main(void)
        {
            float weight[5];
            weight[0] = 0.227027;
            weight[1] = 0.1945946;
            weight[2] = 0.1216216;
            weight[3] = 0.054054;
            weight[4] = 0.016216;
        
            float total = 0.227027 + 0.1945946 + 0.1216216 + 0.054054 + 0.016216;
        
            vec2 textOffset = vec2(1.0 / textureWidth, 1.0 / textureHeight);
            vec4 result = texture2D(texture, textCoord) * weight[0];
        
            if(horizontal)
            {
                for(int i = 1; i < 5; ++i)
                {
                    vec2 offset = vec2(textOffset.x * float(i), 0.0);
                    result += texture2D(texture, textCoord + offset) * weight[i];
                    result += texture2D(texture, textCoord - offset) * weight[i];
                }
            }
            else
            {
                for(int i = 1; i < 5; ++i)
                {
                    vec2 offset = vec2(0.0, textOffset.y * float(i));
                    result += texture2D(texture, textCoord + offset) * weight[i];
                    result += texture2D(texture, textCoord - offset) * weight[i];
                }
            }
        
            vec3 dilatation = normalized ? vec3(result.rgb / total) : vec3(result.rgb);
        
            gl_FragColor = vec4(dilatation, 1.0);
        }`;
  },
  /**
   * @description 颜色遮罩片段着色器 根据颜色遮罩调整图像颜色。
   * 变量：
   * uniform vec4 colorMask;：颜色遮罩，包含RGB值和Alpha值。
   * 主要操作：
   * 获取纹理颜色。
   * 将纹理颜色乘以颜色遮罩。
   * 最终输出调整后的颜色
   * @returns {string}
   */
  getColorMaskShaderCode() {
    return `
        precision mediump float;

        varying vec2 textCoord;
        
        uniform sampler2D texture;
        uniform vec4 colorMask;
        uniform bool isColorMaskOverride;

        void main(void) 
        {
            vec3 mask = texture2D(texture, textCoord.xy).rgb;
            
            gl_FragColor = vec4((isColorMaskOverride ? vec3(1.0) : mask.rgb) * colorMask.rgb, mask.r * colorMask.a);
        }`;
  },
  /**
   * @description 基本顶点着色器 将顶点坐标转换为纹理坐标，并设置顶点位置。
   * 变量：
   * attribute vec3 vertex;：顶点位置。
   * varying vec2 textCoord;：纹理坐标，传递到片段着色器。
   * 主要操作：
   * 将顶点坐标转换为纹理坐标（范围从[-1, 1]到[0, 1]）。
   * 设置顶点位置。
   * @returns {string}
   */
  getBasicVertexShaderCode() {
    return `
        attribute vec3 vertex;
        
        varying vec2 textCoord;

        void main(void) 
        {
            textCoord = (vertex.xy + 1.0) / 2.0;
            gl_Position = vec4(vertex, 1.0);
        }`;
  },
  getOffsetFragmentShaderCode() {
    return `precision mediump float;

                varying vec2 textCoord;
                
                uniform sampler2D texture;
                uniform float horizontalOffset;
                uniform float verticalOffset;
                uniform float textureWidth;
                uniform float textureHeight;
                
                void main(void) 
                {
                    vec2 textOffset = vec2(horizontalOffset / textureWidth, verticalOffset / textureHeight);
                    vec4 color = texture2D(texture, textCoord + textOffset);
                    gl_FragColor = color;
                }`;
  }
};
const FJShaderUtil$1 = FJShaderUtil;

class FJShader {
  constructor(gl, vertexShader, fragmentShader) {
    let compiledVertexShader = this.compileShader(gl, "vertex", vertexShader), compiledFragmentShader = this.compileShader(gl, "fragment", fragmentShader);
    this.shaderProgram = gl.createProgram(), gl.attachShader(this.shaderProgram, compiledVertexShader), gl.attachShader(this.shaderProgram, compiledFragmentShader), gl.linkProgram(this.shaderProgram), gl.getProgramParameter(this.shaderProgram, gl.LINK_STATUS) || console.error("Couldn't link the shader program"), gl.deleteShader(compiledVertexShader), gl.deleteShader(compiledFragmentShader);
  }
  use(gl) {
    gl.useProgram(this.shaderProgram);
  }
  setVertexAttribArray(gl, name, size, type, normalized, stride, offset) {
    let location = gl.getAttribLocation(this.shaderProgram, name);
    gl.enableVertexAttribArray(location), gl.vertexAttribPointer(location, size, type, normalized, stride, offset);
  }
  setIntUniform(gl, name, value) {
    let location = gl.getUniformLocation(this.shaderProgram, name);
    gl.uniform1i(location, value);
  }
  setBoolUniform(gl, name, value) {
    let location = gl.getUniformLocation(this.shaderProgram, name);
    gl.uniform1i(location, Boolean(value));
  }
  setFloatUniform(gl, name, value) {
    let location = gl.getUniformLocation(this.shaderProgram, name);
    gl.uniform1f(location, value);
  }
  setVec4Uniform(gl, name, x, y, z, w) {
    let location = gl.getUniformLocation(this.shaderProgram, name);
    gl.uniform4f(location, x, y, z, w);
  }
  compileShader(gl, shaderType, shaderSrc) {
    let shader;
    if ("fragment" == shaderType)
      shader = gl.createShader(gl.FRAGMENT_SHADER);
    else {
      if ("vertex" != shaderType)
        return console.error(`Shader type: ${shaderType} unhandled`), null;
      shader = gl.createShader(gl.VERTEX_SHADER);
    }
    return gl.shaderSource(shader, shaderSrc), gl.compileShader(shader), gl.getShaderParameter(shader, gl.COMPILE_STATUS) ? shader : (console.error(gl.getShaderInfoLog(shader)), null);
  }
}
const FJShader$1 = FJShader;

class FJCanvasWebGL {
  // 初始化：获取Canvas和2D上下文，创建一个用于WebGL操作的Canvas，并初始化WebGL上下文。
  // 设置WebGL参数：如视口尺寸、混合函数和禁用深度测试等。
  // 构建四边形缓冲区：调用buildQuad方法创建一个包含四个顶点的缓冲区。
  // 加载着色器：调用loadShaders方法加载并初始化各类着色器。
  constructor(canvas) {
    this.treshold = 0.3;
    this.canvas = canvas;
    this.ctx = this.canvas.getContext("2d");
    this.webglCanvas = document.createElement("canvas");
    try {
      this.gl = this.webglCanvas.getContext("webgl", {
        premultipliedAlpha: false,
        preserveDrawingBuffer: true
      });
      this.gl.viewportWidth = this.webglCanvas.width;
      this.gl.viewportHeight = this.webglCanvas.height;
      this.gl.blendFunc(this.gl.ONE, this.gl.ONE_MINUS_SRC_ALPHA);
      this.gl.enable(this.gl.BLEND);
      this.gl.disable(this.gl.DEPTH_TEST);
    } catch (error) {
      console.error(error);
    }
    if (!this.gl)
      alert("Couldn't initialize WebGL");
    this.quad = this.buildQuad();
    this.loadShaders();
  }
  /**
   * @description 加载着色
   * 创建着色器实例：使用前面提供的着色器代码创建四个着色器实例。
   * 配置顶点属性数组：为每个着色器设置顶点属性数组，指定顶点数据的格式。
   */
  loadShaders() {
    this.baseShader = new FJShader$1(
      this.gl,
      FJShaderUtil$1.getBasicVertexShaderCode(),
      FJShaderUtil$1.getBasicFragmentShaderCode()
    );
    this.baseShader.setVertexAttribArray(this.gl, "vertex", this.quad.itemSize, this.gl.FLOAT, false, 0, 0);
    this.thresholdShader = new FJShader$1(
      this.gl,
      FJShaderUtil$1.getBasicVertexShaderCode(),
      FJShaderUtil$1.getThresholdFragmentShaderCode()
    );
    this.thresholdShader.setVertexAttribArray(this.gl, "vertex", this.quad.itemSize, this.gl.FLOAT, false, 0, 0);
    this.dilatationShader = new FJShader$1(
      this.gl,
      FJShaderUtil$1.getBasicVertexShaderCode(),
      FJShaderUtil$1.getDilatationShaderCode()
    );
    this.dilatationShader.setVertexAttribArray(this.gl, "vertex", this.quad.itemSize, this.gl.FLOAT, false, 0, 0);
    this.maskColorShader = new FJShader$1(
      this.gl,
      FJShaderUtil$1.getBasicVertexShaderCode(),
      FJShaderUtil$1.getColorMaskShaderCode()
    );
    this.maskColorShader.setVertexAttribArray(this.gl, "vertex", this.quad.itemSize, this.gl.FLOAT, false, 0, 0);
  }
  /**
   * @description 构建四边形
   * 创建顶点缓冲区：创建并绑定顶点缓冲区，将顶点数据传入WebGL上下文中。
   * @returns {WebGLBuffer | AudioBuffer}
   */
  buildQuad() {
    let vertices = [-1, 1, 0, -1, -1, 0, 1, 1, 0, 1, -1, 0];
    let positionBuffer = this.gl.createBuffer();
    this.gl.bindBuffer(this.gl.ARRAY_BUFFER, positionBuffer);
    this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array(vertices), this.gl.STATIC_DRAW);
    positionBuffer.itemSize = 3;
    positionBuffer.numItems = 4;
    return positionBuffer;
  }
  /**
   * @description 绘制
   * 加载纹理：将图像加载为纹理。
   * 创建帧缓冲区：构建用于中间结果存储的帧缓冲区。
   * 各个处理步骤：依次执行阈值处理、扩散处理、颜色遮罩和阴影处理。
   * 组合处理结果：将各部分组合在一起，并最终绘制到2D Canvas上。
   * @param image
   * @param borderProperties
   */
  draw(image, borderProperties) {
    let firstPass = "original";
    let texture = this.loadTexture(image);
    let fbData = this.buildFrameBuffers();
    this.gl.viewport(0, 0, this.gl.viewportWidth, this.gl.viewportHeight);
    this.gl.clearColor(0, 0, 0, 0);
    this.treshHoldPass(fbData[0].fb, texture);
    if (borderProperties.borderSize > 0) {
      firstPass = "border";
      this.dilatationPass(fbData[0], fbData[1], borderProperties.borderSize, true);
      this.colorMaskPass(fbData[2].fb, fbData[0].texture, borderProperties.borderColor, 255);
    }
    if (borderProperties.borderSize > 0)
      this.compositionPass(fbData[2].texture, "border" === firstPass);
    this.compositionPass(texture, "original" === firstPass, true);
    this.ctx.drawImage(
      this.webglCanvas,
      (this.webglCanvas.width - this.canvas.width) / 2,
      (this.webglCanvas.height - this.canvas.height) / 2,
      this.canvas.width,
      this.canvas.height,
      0,
      0,
      this.canvas.width,
      this.canvas.height
    );
    this.gl.bindTexture(this.gl.TEXTURE_2D, null);
    this.gl.deleteTexture(texture);
    this.deleteFrameBuffers(fbData);
  }
  /**
   * @description 绘制场景
   * 绑定四边形缓冲区并绘制：将绑定的四边形缓冲区绘制为三角形条带。
   */
  drawScene() {
    this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.quad);
    this.gl.drawArrays(this.gl.TRIANGLE_STRIP, 0, this.quad.numItems);
  }
  /**
   * @description 阈值处理：
   * @param fb
   * @param texture
   */
  treshHoldPass(fb, texture) {
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, fb);
    this.thresholdShader.use(this.gl);
    this.gl.activeTexture(this.gl.TEXTURE0);
    this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
    this.thresholdShader.setIntUniform(this.gl, "texture", 0);
    this.thresholdShader.setFloatUniform(this.gl, "thresHold", this.treshold);
    this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
    this.drawScene();
  }
  /**
   * @description 组合处理
   * @param texture
   * @param clear
   * @param premultipliedAlpha
   */
  compositionPass(texture, clear = false, premultipliedAlpha = false) {
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null);
    this.baseShader.use(this.gl);
    this.gl.activeTexture(this.gl.TEXTURE0);
    this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
    this.baseShader.setIntUniform(this.gl, "texture", 0);
    this.baseShader.setIntUniform(this.gl, "premultipleAlpha", premultipliedAlpha);
    if (clear)
      this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
    this.drawScene();
  }
  /**
   * @description 扩散处理
   * @param fbA
   * @param fbB
   * @param dilatations
   * @param normalized
   */
  dilatationPass(fbA, fbB, dilatations, normalized) {
    for (let i = 0; i < dilatations; i++) {
      let horizontal = true;
      for (let j = 0; j < 2; j++) {
        let buffer = fbB.fb, texture = fbA.texture;
        if (!horizontal)
          buffer = fbA.fb, texture = fbB.texture;
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, buffer);
        this.dilatationShader.use(this.gl);
        this.gl.activeTexture(this.gl.TEXTURE0);
        this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
        this.dilatationShader.setIntUniform(this.gl, "texture", 0);
        this.dilatationShader.setIntUniform(this.gl, "horizontal", horizontal);
        this.dilatationShader.setFloatUniform(this.gl, "textureWidth", this.gl.viewportWidth);
        this.dilatationShader.setFloatUniform(this.gl, "textureHeight", this.gl.viewportHeight);
        this.dilatationShader.setIntUniform(this.gl, "normalized", normalized);
        this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
        this.drawScene();
        horizontal = !horizontal;
      }
    }
  }
  /**
   * @description 颜色遮罩处理
   * @param fb
   * @param texture
   * @param color
   * @param alpha
   * @param isColorMaskOverride
   */
  colorMaskPass(fb, texture, color, alpha, isColorMaskOverride = false) {
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, fb);
    this.maskColorShader.use(this.gl);
    this.gl.activeTexture(this.gl.TEXTURE0);
    this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
    this.maskColorShader.setIntUniform(this.gl, "texture", 0);
    this.maskColorShader.setBoolUniform(this.gl, "isColorMaskOverride", isColorMaskOverride);
    this.maskColorShader.setVec4Uniform(
      this.gl,
      "colorMask",
      color[0] / 255,
      color[1] / 255,
      color[2] / 255,
      alpha / 255
    );
    this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
    this.drawScene();
  }
  /**
   * @description 帧缓冲区的创建和管理
   * 创建三个纹理和帧缓冲区：调用createTextureFB和createFramebuffer方法分别创建三个纹理和对应的帧缓冲区。
   * 返回包含这些纹理和帧缓冲区的数组：以便在后续的绘制过程中使用。
   * @returns {[{texture: *, fb: *},{texture: *, fb: *},{texture: *, fb: *}]}
   */
  buildFrameBuffers() {
    let textA = this.createTextureFB();
    let fbA = this.createFramebuffer(textA);
    let textB = this.createTextureFB();
    let fbB = this.createFramebuffer(textB);
    let textC = this.createTextureFB();
    let fbC = this.createFramebuffer(textC);
    let textD = this.createTextureFB();
    let fbD = this.createFramebuffer(textD);
    return [
      { texture: textA, fb: fbA },
      { texture: textB, fb: fbB },
      { texture: textC, fb: fbC },
      { texture: textD, fb: fbD }
    ];
  }
  /**
   * @description 删除帧缓冲区
   * @param frameBuffers
   */
  deleteFrameBuffers(frameBuffers) {
    for (let i = 0; i < frameBuffers.length; i++) {
      this.gl.deleteTexture(frameBuffers[i].texture);
      this.gl.deleteFramebuffer(frameBuffers[i].fb);
    }
  }
  /**
   * @description 创建帧缓冲区
   * 创建并绑定帧缓冲区：调用createFramebuffer方法创建帧缓冲区，并绑定到WebGL上下文。
   * 附加纹理到帧缓冲区：通过framebufferTexture2D方法，将纹理附加到帧缓冲区的颜色附件上。
   * @param texture
   * @returns {*}
   */
  createFramebuffer(texture) {
    let fb = this.gl.createFramebuffer();
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, fb);
    this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, texture, 0);
    return fb;
  }
  /**
   * @description 创建纹理帧缓冲区
   * 创建并绑定纹理：创建纹理并绑定到WebGL上下文。
   * 定义纹理的格式和参数：通过texImage2D方法定义纹理的大小和格式，通过texParameteri方法设置纹理参数（如过滤器和包装模式）。
   * @returns {WebGLTexture}
   */
  createTextureFB() {
    let texture = this.gl.createTexture();
    this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
    this.gl.texImage2D(
      this.gl.TEXTURE_2D,
      0,
      this.gl.RGBA,
      this.gl.viewportWidth,
      this.gl.viewportHeight,
      0,
      this.gl.RGBA,
      this.gl.UNSIGNED_BYTE,
      null
    );
    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR);
    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
    return texture;
  }
  /**
   * @description 加载纹理
   * 调整图像尺寸：将图像调整为最接近的2的幂大小，以兼容WebGL。
   * 创建并配置纹理：创建纹理、配置纹理参数，并将调整后的图像加载到纹理中。
   * @param image
   * @returns {WebGLTexture}
   */
  loadTexture(image) {
    let resizedImage = this.resizeToPowerOfTwo(image);
    let texture = this.gl.createTexture();
    this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, true);
    this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.gl.RGBA, this.gl.UNSIGNED_BYTE, resizedImage);
    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);
    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR_MIPMAP_NEAREST);
    this.gl.generateMipmap(this.gl.TEXTURE_2D);
    this.gl.bindTexture(this.gl.TEXTURE_2D, null);
    return texture;
  }
  /**
   * @description 调整图像尺寸到2的幂
   * 计算新的宽高：计算最接近的2的幂大小的新宽高。
   * 调整图像尺寸：将图像绘制到新的Canvas上，并返回新的Canvas。
   * @param image
   * @returns {*}
   */
  resizeToPowerOfTwo(image) {
    let newWidth = this.getPowerOfTwo(image.width);
    let newHeight = this.getPowerOfTwo(image.height);
    let newCanvas = this.resizeCanvas(image, newWidth, newHeight);
    this.webglCanvas.width = newWidth;
    this.webglCanvas.height = newHeight;
    this.canvas.width = image.width;
    this.canvas.height = image.height;
    this.gl.viewportWidth = this.webglCanvas.width;
    this.gl.viewportHeight = this.webglCanvas.height;
    return newCanvas;
  }
  /**
   * @description 调整Canvas尺寸
   * 创建新Canvas并绘制图像：创建一个新的Canvas，将旧Canvas的内容居中绘制到新的Canvas上。
   * @param oldCanvas
   * @param newWidth
   * @param newHeight
   * @returns {HTMLCanvasElement}
   */
  resizeCanvas(oldCanvas, newWidth, newHeight) {
    let newCanvas = document.createElement("canvas");
    let context = newCanvas.getContext("2d");
    newCanvas.width = newWidth;
    newCanvas.height = newHeight;
    let x = (newWidth - oldCanvas.width) / 2;
    let y = (newHeight - oldCanvas.height) / 2;
    context.drawImage(oldCanvas, x, y);
    return newCanvas;
  }
  /**
   * @description 计算2的幂
   * @param value
   * @returns {number}
   */
  getPowerOfTwo(value) {
    let pow = 2;
    while (pow < value)
      pow *= 2;
    return pow;
  }
  /**
   * @description 阈值属性
   * @returns {*}
   */
  get treshold() {
    return this._treshold;
  }
  /**
   * @description 阈值属性
   * @param value
   */
  set treshold(value) {
    isNaN(value) || value < 0 || value > 1 ? console.warn(`Invalid value for the alpha treshold: ${value}`) : this._treshold = value;
  }
}
const FJCanvasWebGL$1 = FJCanvasWebGL;

class FJSingleStroke extends FJCanvasWebGL$1 {
  /**
   * @description 绘制
   * 加载纹理：将图像加载为纹理。
   * 创建帧缓冲区：构建用于中间结果存储的帧缓冲区。
   * 各个处理步骤：依次执行阈值处理、扩散处理、颜色遮罩和阴影处理。
   * 组合处理结果：将各部分组合在一起，并最终绘制到2D Canvas上。
   * @param image
   * @param borderProperties
   */
  draw(image, borderProperties) {
    let firstPass = "original";
    let texture = this.loadTexture(image);
    let fbData = this.buildFrameBuffers();
    this.gl.viewport(0, 0, this.gl.viewportWidth, this.gl.viewportHeight);
    this.gl.clearColor(0, 0, 0, 0);
    this.treshHoldPass(fbData[0].fb, texture);
    if (borderProperties.borderSize > 0) {
      firstPass = "border";
      this.dilatationPass(fbData[0], fbData[1], borderProperties.borderSize, true);
      this.colorMaskPass(
        fbData[2].fb,
        fbData[0].texture,
        borderProperties.borderColor,
        borderProperties.borderAlpha,
        true
      );
    }
    if (borderProperties.borderSize > 0)
      this.compositionPass(fbData[2].texture, "border" === firstPass);
    this.compositionPass(texture, "original" === firstPass, true);
    this.ctx.drawImage(
      this.webglCanvas,
      (this.webglCanvas.width - this.canvas.width) / 2,
      (this.webglCanvas.height - this.canvas.height) / 2,
      this.canvas.width,
      this.canvas.height,
      0,
      0,
      this.canvas.width,
      this.canvas.height
    );
    this.gl.bindTexture(this.gl.TEXTURE_2D, null);
    this.gl.deleteTexture(texture);
    this.deleteFrameBuffers(fbData);
  }
}
const FJSingleStroke$1 = FJSingleStroke;

class FJDoubleStroke extends FJCanvasWebGL$1 {
  /**
   * @description 帧缓冲区的创建和管理
   * 创建三个纹理和帧缓冲区：调用createTextureFB和createFramebuffer方法分别创建三个纹理和对应的帧缓冲区。
   * 返回包含这些纹理和帧缓冲区的数组：以便在后续的绘制过程中使用。
   * @returns {[{texture: *, fb: *},{texture: *, fb: *},{texture: *, fb: *}]}
   */
  buildFrameBuffers() {
    let textA = this.createTextureFB();
    let fbA = this.createFramebuffer(textA);
    let textB = this.createTextureFB();
    let fbB = this.createFramebuffer(textB);
    let textC = this.createTextureFB();
    let fbC = this.createFramebuffer(textC);
    let textD = this.createTextureFB();
    let fbD = this.createFramebuffer(textD);
    let textE = this.createTextureFB();
    let fbE = this.createFramebuffer(textE);
    return [
      { texture: textA, fb: fbA },
      { texture: textB, fb: fbB },
      { texture: textC, fb: fbC },
      { texture: textD, fb: fbD },
      { texture: textE, fb: fbE }
    ];
  }
  /**
   * @description 绘制
   * 加载纹理：将图像加载为纹理。
   * 创建帧缓冲区：构建用于中间结果存储的帧缓冲区。
   * 各个处理步骤：依次执行阈值处理、扩散处理、颜色遮罩和阴影处理。
   * 组合处理结果：将各部分组合在一起，并最终绘制到2D Canvas上。
   * @param image
   * @param borderProperties
   */
  draw(image, borderProperties) {
    let firstPass = "original";
    let texture = this.loadTexture(image);
    let fbData = this.buildFrameBuffers();
    this.gl.viewport(0, 0, this.gl.viewportWidth, this.gl.viewportHeight);
    this.gl.clearColor(0, 0, 0, 0);
    this.treshHoldPass(fbData[0].fb, texture);
    if (borderProperties.borderSize > 0) {
      firstPass = "border";
      const color = FJColorUtil$1.HexToRgb(
        FJColorUtil$1.getLightColor(
          FJColorUtil$1.RgbToHex(
            borderProperties.borderColor[0],
            borderProperties.borderColor[1],
            borderProperties.borderColor[2]
          ),
          0.5
        )
      );
      this.dilatationPass(fbData[0], fbData[1], borderProperties.borderSize, true);
      this.colorMaskPass(fbData[2].fb, fbData[0].texture, color, borderProperties.borderAlpha);
      this.dilatationPass(fbData[0], fbData[3], borderProperties.borderSize * 1.5, true);
      this.colorMaskPass(
        fbData[4].fb,
        fbData[0].texture,
        borderProperties.borderColor,
        borderProperties.borderAlpha,
        true
      );
    }
    if (borderProperties.borderSize > 0) {
      this.compositionPass(fbData[4].texture, "border" === firstPass);
      this.compositionPass(fbData[2].texture, false);
    }
    this.compositionPass(texture, "original" === firstPass, true);
    this.ctx.drawImage(
      this.webglCanvas,
      (this.webglCanvas.width - this.canvas.width) / 2,
      (this.webglCanvas.height - this.canvas.height) / 2,
      this.canvas.width,
      this.canvas.height,
      0,
      0,
      this.canvas.width,
      this.canvas.height
    );
    this.gl.bindTexture(this.gl.TEXTURE_2D, null);
    this.gl.deleteTexture(texture);
    this.deleteFrameBuffers(fbData);
  }
}
const FJDoubleStroke$1 = FJDoubleStroke;

class FJOffsetStroke extends FJCanvasWebGL$1 {
  /**
   * @description 绘制
   * 加载纹理：将图像加载为纹理。
   * 创建帧缓冲区：构建用于中间结果存储的帧缓冲区。
   * 各个处理步骤：依次执行阈值处理、扩散处理、颜色遮罩和阴影处理。
   * 组合处理结果：将各部分组合在一起，并最终绘制到2D Canvas上。
   * @param image
   * @param borderProperties
   */
  draw(image, borderProperties) {
    let firstPass = "original";
    let texture = this.loadTexture(image);
    let fbData = this.buildFrameBuffers();
    this.gl.viewport(0, 0, this.gl.viewportWidth, this.gl.viewportHeight);
    this.gl.clearColor(0, 0, 0, 0);
    this.treshHoldPass(fbData[0].fb, texture);
    if (borderProperties.borderSize > 0) {
      firstPass = "border";
      this.dilatationPass(fbData[0], fbData[1], borderProperties.borderSize, true);
      const ref = borderProperties.offset;
      const x = ref * Math.cos(borderProperties.direction / 180 * Math.PI);
      const y = ref * Math.sin(borderProperties.direction / 180 * Math.PI);
      this.horizontalOffsetPass(fbData[1], fbData[0], x, y);
      this.colorMaskPass(
        fbData[2].fb,
        fbData[0].texture,
        borderProperties.borderColor,
        borderProperties.borderAlpha,
        true
      );
    }
    if (borderProperties.borderSize > 0)
      this.compositionPass(fbData[2].texture, "border" === firstPass);
    this.compositionPass(texture, "original" === firstPass, true);
    this.ctx.drawImage(
      this.webglCanvas,
      (this.webglCanvas.width - this.canvas.width) / 2,
      (this.webglCanvas.height - this.canvas.height) / 2,
      this.canvas.width,
      this.canvas.height,
      0,
      0,
      this.canvas.width,
      this.canvas.height
    );
    this.gl.bindTexture(this.gl.TEXTURE_2D, null);
    this.gl.deleteTexture(texture);
    this.deleteFrameBuffers(fbData);
  }
  /**
   * @description 加载着色
   * 创建着色器实例：使用前面提供的着色器代码创建四个着色器实例。
   * 配置顶点属性数组：为每个着色器设置顶点属性数组，指定顶点数据的格式。
   */
  loadShaders() {
    super.loadShaders();
    this.offsetShader = new FJShader$1(
      this.gl,
      FJShaderUtil$1.getBasicVertexShaderCode(),
      FJShaderUtil$1.getOffsetFragmentShaderCode()
    );
    this.offsetShader.setVertexAttribArray(this.gl, "vertex", this.quad.itemSize, this.gl.FLOAT, false, 0, 0);
  }
  horizontalOffsetPass(fbA, fbB, x, y) {
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, fbB.fb);
    this.offsetShader.use(this.gl);
    this.gl.activeTexture(this.gl.TEXTURE0);
    this.gl.bindTexture(this.gl.TEXTURE_2D, fbA.texture);
    this.offsetShader.setIntUniform(this.gl, "texture", 0);
    this.offsetShader.setFloatUniform(this.gl, "textureWidth", this.gl.viewportWidth);
    this.offsetShader.setFloatUniform(this.gl, "textureHeight", this.gl.viewportHeight);
    this.offsetShader.setFloatUniform(this.gl, "horizontalOffset", x);
    this.offsetShader.setFloatUniform(this.gl, "verticalOffset", y);
    this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
    this.drawScene();
  }
}
const FJOffsetStroke$1 = FJOffsetStroke;

class FJImageStrokeManager {
  constructor() {
    this._webGLCanvas = null;
    this._tempCanvas = new OffscreenCanvas(0, 0);
    this._tempCanvasCtx = this._tempCanvas.getContext("2d");
  }
  /**
   * @description 引用图片轮廓（描边）
   * @param canvas
   * @param strokeInfo
   * @param options
   */
  applyImageStroke(canvas, strokeInfo, options = {}) {
    const { type, width, color, direction, offset, opacity } = strokeInfo;
    const { originalWidth, originalHeight } = options;
    const borderProps = new FJBorderProperties$1(20, 0, [0, 255, 0], [0, 255, 0], 0, 0);
    let borderSize = width * 2;
    this._webGLCanvas = null;
    switch (type) {
      case "single-stroke": {
        borderProps.borderSize = width;
        borderProps.borderColor = FJColorUtil$1.HexToRgb(color);
        borderProps.borderAlpha = opacity / 100 * 255;
        if (!this._webGLCanvas) {
          this._webGLCanvas = new FJSingleStroke$1(canvas);
        }
        borderSize = width * 2;
        break;
      }
      case "double-stroke": {
        borderProps.borderSize = width;
        borderProps.borderColor = FJColorUtil$1.HexToRgb(color);
        borderProps.borderAlpha = opacity / 100 * 255;
        borderSize = width * 2 * 2;
        if (!this._webGLCanvas) {
          this._webGLCanvas = new FJDoubleStroke$1(canvas);
        }
        break;
      }
      case "glow-stroke": {
        borderSize = width * 4 + 60;
        if (width > 0) {
          borderProps.borderSize = width;
          borderProps.borderColor = FJColorUtil$1.HexToRgb(color);
          borderProps.borderAlpha = opacity / 100 * 255;
          if (!this._webGLCanvas) {
            this._webGLCanvas = new FJSingleStroke$1(canvas);
          }
        }
        break;
      }
      case "offset-stroke": {
        borderProps.borderSize = 8;
        borderSize = 8 * 2 + offset * 1.2;
        borderProps.offset = offset;
        borderProps.borderColor = FJColorUtil$1.HexToRgb(color);
        borderProps.direction = direction;
        borderProps.borderAlpha = opacity / 100 * 255;
        if (!this._webGLCanvas) {
          this._webGLCanvas = new FJOffsetStroke$1(canvas);
        }
        break;
      }
      case "shadow-stroke": {
        borderSize = 60 + offset * 1.1;
        break;
      }
      case "border-shadow-stroke": {
        borderProps.borderSize = width;
        borderProps.borderColor = FJColorUtil$1.HexToRgb(color);
        borderProps.borderAlpha = opacity / 100 * 255;
        if (!this._webGLCanvas) {
          this._webGLCanvas = new FJSingleStroke$1(canvas);
        }
        borderSize = width * 2 + 60 + offset * 1.1;
      }
    }
    this._tempCanvas.width = originalWidth;
    this._tempCanvas.height = originalHeight;
    const scaleFactor = Math.min(
      (this._tempCanvas.width - borderSize * 2) / this._tempCanvas.width,
      (this._tempCanvas.height - borderSize * 2) / this._tempCanvas.height
    );
    const x = originalWidth * (1 - scaleFactor) / 2;
    const y = originalHeight * (1 - scaleFactor) / 2;
    this._tempCanvasCtx.drawImage(canvas, x, y, originalWidth * scaleFactor, originalHeight * scaleFactor);
    if (!this._webGLCanvas) {
      canvas.width = this._tempCanvas.width;
      canvas.height = this._tempCanvas.height;
      canvas.getContext("2d").drawImage(this._tempCanvas, 0, 0, this._tempCanvas.width, this._tempCanvas.height);
    } else {
      this._webGLCanvas.draw(this._tempCanvas, borderProps);
    }
  }
  applyImageStrokeByShadow(strokeCoverCanvas, strokeInfo) {
    const {
      type,
      color,
      opacity,
      shadowColor,
      shadowOpacity,
      blur,
      direction,
      offset,
      glowColor,
      glowOpacity,
      glowWidth
    } = strokeInfo;
    const strokeCoverCanvasCtx = strokeCoverCanvas.getContext("2d");
    this._tempCanvas.width = strokeCoverCanvas.width;
    this._tempCanvas.height = strokeCoverCanvas.height;
    this._tempCanvasCtx.drawImage(strokeCoverCanvas, 0, 0, strokeCoverCanvas.width, strokeCoverCanvas.height);
    strokeCoverCanvas.width = this._tempCanvas.width;
    strokeCoverCanvas.height = this._tempCanvas.height;
    switch (type) {
      case "glow-stroke": {
        const useColor = FJColorUtil$1.HexToRgb(glowColor);
        strokeCoverCanvasCtx.shadowBlur = glowWidth;
        strokeCoverCanvasCtx.shadowColor = `rgba(${useColor[0]}, ${useColor[1]}, ${useColor[2]}, ${glowOpacity / 100})`;
        strokeCoverCanvasCtx.shadowOffsetX = 0;
        strokeCoverCanvasCtx.shadowOffsetY = 0;
        break;
      }
      case "border-shadow-stroke":
      case "shadow-stroke": {
        const curColor = type === "border-shadow-stroke" ? shadowColor : color;
        const curOpacity = type === "border-shadow-stroke" ? shadowOpacity : opacity;
        const useColor = FJColorUtil$1.HexToRgb(curColor);
        const x = offset * Math.cos(direction / 180 * Math.PI);
        const y = offset * Math.sin(direction / 180 * Math.PI);
        strokeCoverCanvasCtx.shadowBlur = blur;
        strokeCoverCanvasCtx.shadowColor = `rgba(${useColor[0]}, ${useColor[1]}, ${useColor[2]}, ${curOpacity / 100})`;
        strokeCoverCanvasCtx.shadowOffsetX = x;
        strokeCoverCanvasCtx.shadowOffsetY = y;
        break;
      }
    }
    strokeCoverCanvasCtx.drawImage(this._tempCanvas, 0, 0, this._tempCanvas.width, this._tempCanvas.height);
  }
  /**
   * @description 获取描边样式
   * @param strokeInfo
   * @returns {string}
   */
  getStyleFilter(strokeInfo) {
    const {
      type,
      color,
      opacity,
      shadowColor,
      shadowOpacity,
      blur,
      direction,
      offset,
      glowColor,
      glowOpacity,
      glowWidth
    } = strokeInfo;
    switch (type) {
      case "glow-stroke": {
        const useColor = FJColorUtil$1.HexToRgb(glowColor);
        return `drop-shadow(rgba(${useColor[0]}, ${useColor[1]}, ${useColor[2]}, ${glowOpacity / 100 * 255}) 0px 0px ${glowWidth}px)`;
      }
      case "border-shadow-stroke":
      case "shadow-stroke": {
        const curColor = type === "border-shadow-stroke" ? shadowColor : color;
        const curOpacity = type === "border-shadow-stroke" ? shadowOpacity : opacity;
        const useColor = FJColorUtil$1.HexToRgb(curColor);
        const x = offset * Math.cos(direction / 180 * Math.PI);
        const y = offset * Math.sin(direction / 180 * Math.PI);
        return `drop-shadow(${x}px ${y}px ${blur}px rgba(${useColor[0]}, ${useColor[1]}, ${useColor[2]}, ${curOpacity / 100 * 255}))`;
      }
      default:
        return "none";
    }
  }
}
const FJImageStrokeManagerSingleton = new FJImageStrokeManager();
const FJImageStrokeManagerSingleton$1 = FJImageStrokeManagerSingleton;

const STROKE_LIST = [
  { type: "single-stroke", color: "#ffffff", opacity: 100, width: 20 },
  { type: "double-stroke", color: "#F675D0", opacity: 100, width: 10 },
  {
    type: "glow-stroke",
    color: "#F4F22D",
    opacity: 100,
    width: 4,
    glowColor: "#F4F22D",
    glowOpacity: 100,
    glowWidth: 10
  },
  { type: "offset-stroke", color: "#ffffff", opacity: 100, direction: 180, offset: 30 },
  { type: "shadow-stroke", color: "#000000", opacity: 50, blur: 20, direction: 180, offset: 10 },
  {
    type: "border-shadow-stroke",
    color: "#ffffff",
    opacity: 100,
    shadowColor: "#000000",
    shadowOpacity: 50,
    width: 20,
    blur: 20,
    direction: 180,
    offset: 10
  }
];
const IMAGE_STROKE_LIMIT_CONFIG = {
  "single-stroke": {
    minWidth: 2,
    maxWidth: 30
  },
  "double-stroke": {
    minWidth: 2,
    maxWidth: 30
  },
  "glow-stroke": {
    minWidth: 2,
    maxWidth: 30,
    minGlowWidth: 0,
    maxGlowWidth: 100
  },
  "offset-stroke": {
    minOffset: 10,
    maxOffset: 100
  },
  "shadow-stroke": {
    minBlur: 10,
    maxBlur: 80,
    minOffset: 10,
    maxOffset: 50
  },
  "border-shadow-stroke": {
    minWidth: 2,
    maxWidth: 30,
    minBlur: 10,
    maxBlur: 80,
    minOffset: 10,
    maxOffset: 50
  }
};
const IMAGE_STROKE_CONFIG = {
  "single-stroke": {
    color: true,
    opacity: true,
    width: true
  },
  "double-stroke": {
    color: true,
    opacity: true,
    width: true
  },
  "glow-stroke": {
    color: true,
    opacity: true,
    width: true,
    glowColor: true,
    glowOpacity: true,
    glowWidth: true
  },
  "offset-stroke": {
    color: true,
    opacity: true,
    direction: true,
    offset: true
  },
  "shadow-stroke": {
    color: true,
    opacity: true,
    blur: true,
    direction: true,
    offset: true
  },
  "border-shadow-stroke": {
    color: true,
    opacity: true,
    shadowColor: true,
    shadowOpacity: true,
    width: true,
    blur: true,
    direction: true,
    offset: true
  }
};

export { FJImageStrokeManager, IMAGE_STROKE_CONFIG, IMAGE_STROKE_LIMIT_CONFIG, STROKE_LIST, FJImageStrokeManagerSingleton$1 as default };
